import { Platform } from './Platform.js';
export class MemberAdmin {
    constructor(data) {
        this.users = [];
        this.users = data.users;
    }
    get id() {
        var _a;
        return (_a = this.users[0].memberId) !== null && _a !== void 0 ? _a : 'unknown';
    }
    get name() {
        const withName = this.users.find(u => !!u.name);
        return withName ? withName.name : this.users[0].email;
    }
    getResponsibilities(organization) {
        var _a, _b;
        const responsibilities = new Map();
        for (const user of this.users) {
            const permission = organization ? (_a = user.permissions) === null || _a === void 0 ? void 0 : _a.organizationPermissions.get(organization.id) : (_b = user.permissions) === null || _b === void 0 ? void 0 : _b.globalPermissions;
            if (permission) {
                for (const responsibility of permission.responsibilities) {
                    responsibilities.set(responsibility.responsibilityId, responsibility);
                }
            }
        }
        return [...responsibilities.values()].flatMap((r) => {
            var _a, _b, _c;
            // Find name of this responsibility
            if (r.organizationId && r.organizationId === (organization === null || organization === void 0 ? void 0 : organization.id)) {
                const name = (_b = (_a = organization === null || organization === void 0 ? void 0 : organization.privateMeta) === null || _a === void 0 ? void 0 : _a.responsibilities.find(res => res.id === r.responsibilityId)) === null || _b === void 0 ? void 0 : _b.name;
                if (name) {
                    return [name];
                }
            }
            const name = (_c = Platform.shared.config.responsibilities.find(res => res.id === r.responsibilityId)) === null || _c === void 0 ? void 0 : _c.name;
            if (name) {
                return [name];
            }
            return [];
        });
    }
}
//# sourceMappingURL=MemberAdmin.js.map